export default function BuilderPropertiesPanel() {
  return (
    <div className="h-full flex flex-col overflow-hidden">
      <div className="px-3 py-2 text-xs tracking-wide text-purple-300/70">
        PROPERTIES
      </div>
      <div className="h-px bg-white/10 mx-3 mb-2" />

      <div className="flex-1 overflow-auto px-3 text-sm text-purple-300/60">
        Select a component to edit its properties
      </div>
    </div>
  );
}
